import styled from "styled-components";

export const Scrollbar = styled.div`
  height: 87vh;
  ::-webkit-scrollbar-track {
    background-color: #f5f5f5;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #f5f5f5;
  }
  ::-webkit-scrollbar-thumb {
    background: #f5f5f5;
  }
`;

export const Container = styled.main`
  margin-top: 36px;
  padding: 0 20px 0 20px;

  .modal-content {
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    padding: 0 20px 0 20px;
  }
`;

export const Title = styled.h1`
  color: #005ca5;
  font-size: 1.5625rem;
  font-weight: bold;
  margin-top: 50px;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;

  svg {
    margin-left: 10.19px;
    color: #f0b01b;
  }

  ${Title} {
    color: #262626;
    font-size: 1.5625rem;
    font-weight: bold;
    margin: 0;
  }
`;

export const Hr = styled.hr`
  border-color: #c1c1c1;
  border-style: dashed;
  margin: 15px 0px 15px 0px;
`;
